import React from "react";
import { DocumentAttachment, DocumentDownload } from "@carbon/icons-react";
import { bytesToKilobytes, download } from "../../utils/file";
import { Modal } from "./Modal";
import { useTranslation } from "react-i18next";
import { ServerFile } from "../../types/components";

interface DataAgreementModalProps {
  isAgreementModalOpen: boolean;
  setIsAgreementModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleConfirmAgreement: () => void;
  agreementFile?: ServerFile | null;
}

export const DataAgreementModal: React.FC<DataAgreementModalProps> = ({
  isAgreementModalOpen,
  setIsAgreementModalOpen,
  agreementFile,
  handleConfirmAgreement,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isModalOpen={isAgreementModalOpen}
      closeModal={() => setIsAgreementModalOpen(false)}
      title={t("Agreement Clause")}
      subtitle={""}
      firstButtonLabel={t("Close")}
      firstButtonClick={() => setIsAgreementModalOpen(false)}
      secondButtonType={"primary"}
      secondButtonClick={handleConfirmAgreement}
      secondButtonLabel={t("Accept Clause")}
      additionalClassName="sm:max-w-4xl"
      content={
        <div className="flex flex-col gap-4">
          <div className="flex items-start justify-start bg-ghost-110 rounded-md p-4 border border-gray-100 gap-3">
            <div>
              <DocumentAttachment size={40} />
            </div>
            <div className="w-full">
              <div className="flex justify-between items-center w-full">
                <p className="text-black truncate text-[16px] font-normal leading-[20.16px]">
                  {agreementFile?.file_name}
                </p>
                <button onClick={() => download(agreementFile ?? undefined)}>
                  <DocumentDownload className="text-ominimo-400" size={20} />
                </button>
              </div>

              {agreementFile?.file_size && (
                <p className="text-gray-550 truncate text-[15px] font-light leading-[18.9px]">
                  {bytesToKilobytes(agreementFile?.file_size)} KB
                </p>
              )}
            </div>
          </div>
          <div>
            <embed
              src={agreementFile?.file_url}
              type="application/pdf"
              width="100%"
              height="1000"
              title="Embedded PDF Viewer"
            />
          </div>
        </div>
      }
    />
  );
};
